import TimezoneManager from '../api/timezone';

const actions = {
  getItems: async function({state, commit}, {perPage, page, sort, search}) {
    try {
      commit('setIsLoaded', false);

      let response = await state.apiManager.paginateAll(perPage, page, sort,
          search);
      let data = response.data.data;

      commit('setItems', data.items);
      commit('setPage', data.currentPage);
      commit('setPageCount', data.lastPage);
      commit('setPerPage', data.perPage);
      commit('setTotal', data.total);
      commit('setHasMorePages', data.hasMorePages);
      commit('setIsLoaded', true);
      return data;
    } catch ({response}) {
      console.error(response);
    }
  },
  deleteItemById: async function({state, commit}, {id}) {
    try {
      commit('setIsLoaded', false);

      let response = await state.apiManager.deleteById(id);

      commit('deleteItemById', id);

      if ((state.items.length === 0) && ((state.page - 1) > 0)) {
        commit('setPage', state.page - 1);
        commit('setPageCount', state.pageCount - 1);
      }

      commit('setIsLoaded', true);

    } catch ({response}) {
      console.error(response.status);
    }
  },
  addItem: async function({state, commit, dispatch}, object) {
    try {
      commit('setIsLoaded', false);
      commit('setIsChanged', false);
      commit('setValidationError', null);

      let firstPage = 1;
      let response = await state.apiManager.create(object);

      if (state.page === firstPage) {
        if (state.items.length + 1 > state.perPage) {
          commit('removeLastItem');
        }

        commit('addItem', response.data.data);

        if (((state.total + 1) / state.perPage) > state.pageCount) {
          commit('setPageCount', state.pageCount + 1);
        }

        commit('setTotal', state.total + 1);
        commit('setIsLoaded', true);
      } else {
        dispatch('getItems', {perPage: state.perPage, page: firstPage});
      }
    } catch (e) {
      console.error(e);
      commit('setValidationError', e.data.errors);
    } finally {
      if (!state.validationError){
        commit('setIsChanged', true);
      }
    }
  },
  editItem: async function({state, commit}, object) {
    try {
      commit('setIsLoaded', false);
      commit('setIsChanged', false);
      let response = await state.apiManager.update(object);
      commit('editItem', response.data.data);
      commit('setIsLoaded', true);
    } catch (e) {
      console.info(e);
      console.error(e.response.status);
    } finally {
      commit('setIsChanged', true);
    }
  },
  loadTimezones: async function({commit}) {
    try {
      let response = await TimezoneManager.get();
      commit('setTimezones', response.data.data);
    } catch (e) {
      console.info(e);
      console.error(e.response.status);
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/modules/user/vuex/actions.js